var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLinkedinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4856 0H1.85123C1.19811 0 0.669983 0.515625 0.669983 1.15313V14.8438C0.669983 15.4813 1.19811 16 1.85123 16H15.4856C16.1387 16 16.67 15.4813 16.67 14.8469V1.15313C16.67 0.515625 16.1387 0 15.4856 0ZM5.41686 13.6344H3.04186V5.99687H5.41686V13.6344ZM4.22936 4.95625C3.46686 4.95625 2.85123 4.34062 2.85123 3.58125C2.85123 2.82188 3.46686 2.20625 4.22936 2.20625C4.98873 2.20625 5.60436 2.82188 5.60436 3.58125C5.60436 4.3375 4.98873 4.95625 4.22936 4.95625ZM14.3044 13.6344H11.9325V9.92188C11.9325 9.0375 11.9169 7.89687 10.6981 7.89687C9.46373 7.89687 9.27623 8.8625 9.27623 9.85938V13.6344H6.90748V5.99687H9.18248V7.04063H9.21373C9.52936 6.44063 10.3044 5.80625 11.4575 5.80625C13.8606 5.80625 14.3044 7.3875 14.3044 9.44375V13.6344Z",
    fill: "#7F9AA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.669983)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedinIcon);
export default __webpack_public_path__ + "static/media/footer-linkedin-icon.c9dd144943d926b986e8ace5f8d76d20.svg";
export { ForwardRef as ReactComponent };